import React from 'react';
import { Menu } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import LogoutButton from '../LogoutButton'; // Adjusted import path
import { NAV_MENU_CONFIG } from '../../utils/constants';

const TopBar = ({ sidebarOpen, setSidebarOpen }) => {
    const location = useLocation();
    const currentItem = NAV_MENU_CONFIG.items.find(item => item.path === location.pathname);
    const pageTitle = currentItem ? currentItem.description : 'Dashboard';

    return (
        <div className="sticky top-0 z-30 bg-gray-900/80 backdrop-blur-md border-b border-gray-800 px-3 md:px-4 py-2 md:py-2.5 flex items-center justify-between gap-4 transition-all duration-300">
            <div className="flex items-center gap-4">
                <button
                    onClick={() => setSidebarOpen(!sidebarOpen)}
                    className="text-gray-400 hover:text-white transition-colors"
                >
                    <Menu className="w-5 h-5 md:w-6 md:h-6" />
                </button>
                <div className="text-xs md:text-sm text-gray-400 truncate">
                    {pageTitle}
                </div>
            </div>
            <LogoutButton />
        </div>
    );
};

export default TopBar;
